export function sortByIndex<T extends { index: number }>(items: T[]): T[];
export function sortByIndex<T extends { index: number }>(ids: string[], entities: Record<string, T>): string[];
export function sortByIndex<T extends { index: number }>(ids: number[], entities: Record<number, T>): string[];
export function sortByIndex<T extends { index: number }>(items: T[] | string[], entities?: Record<string, T>): unknown {
  if (items.length === 0) {
    return items;
  }

  if (entities == null) {
    return [...items].sort((a, b) => {
      if (typeof a === 'string' || typeof b === 'string') {
        throw new Error('entities must be present when sorting ids array');
      }
      return a.index - b.index;
    });
  }

  return [...(items as string[])].sort((a, b) => {
    const aEntity = entities[a];
    const bEntity = entities[b];
    if (aEntity == null || bEntity == null) {
      throw Error('entity does not exist in dictionary');
    }
    return aEntity.index - bEntity.index;
  });
}
